import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'

const renderIcon = (color: string = "#12976F") => (
    <>
        <path
            d="M2.64648 6.25C2.64648 5.55964 3.20613 5 3.89648 5H26.1024C26.7928 5 27.3524 5.55964 27.3524 6.25C27.3524 6.94036 26.7928 7.5 26.1024 7.5H3.89648C3.20613 7.5 2.64648 6.94036 2.64648 6.25Z"
            fill={color}/>
        <path
            d="M2.64648 15C2.64648 14.3096 3.20613 13.75 3.89648 13.75H26.1024C26.7928 13.75 27.3524 14.3096 27.3524 15C27.3524 15.6904 26.7928 16.25 26.1024 16.25H3.89648C3.20613 16.25 2.64648 15.6904 2.64648 15Z"
            fill={color}/>
        <path
            d="M3.89648 22.5C3.20613 22.5 2.64648 23.0596 2.64648 23.75C2.64648 24.4404 3.20613 25 3.89648 25H26.1024C26.7928 25 27.3524 24.4404 27.3524 23.75C27.3524 23.0596 26.7928 22.5 26.1024 22.5H3.89648Z"
            fill={color}/>

    </>
)

export const Properties: React.FC<IconProps> = ({color, size = 30}) => (
    <IconWrapper {...{size, color, renderIcon}} viewBox={'0 0 30 30'}/>
)
